"use strict";import{IconMore as e}from"../src/elements/IconMore.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-more",e);
//# sourceMappingURL=sp-icon-more.js.map
